// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const toxtricity_low_key: PokeData = {
  "id": 10184,
  "name": "toxtricity-low-key",
  "height": 16,
  "weight": 400,
  "base_experience": 176,
  "types": [
    PokeType.ELECTRIC,
    PokeType.POISON
  ],
  "api_moves": [
    "leer",
    "growl",
    "acid",
    "thunder-shock",
    "toxic",
    "screech",
    "flail",
    "scary-face",
    "swagger",
    "spark",
    "charge",
    "taunt",
    "shock-wave",
    "poison-jab",
    "discharge",
    "acid-spray",
    "belch",
    "noble-roar",
    "boomburst",
    "eerie-impulse",
    "venom-drench",
    "magnetic-flux",
    "nuzzle",
    "tearful-look",
    "overdrive"
  ],
  "moves": [
    "leer",
    "growl",
    "acid",
    "thunder-shock",
    "scary-face",
    "poison-jab",
    "venom-drench",
    "electric-terrain",
    "volt-crash",
    "thunder-punch",
    "electric-wrath",
    "wild-charge",
    "poison-powder"
  ],
  "evolution_chain": {
    "id": 446,
    "item": null,
    "species": [
      {
        "name": "toxel",
        "order": 848,
        "types": [
          PokeType.ELECTRIC,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "toxtricity",
        "order": 849,
        "types": [
          PokeType.ELECTRIC,
          PokeType.POISON
        ],
        "evolves_from_species_id": 848,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 111,
    "speed": 115,
    "ability_power": 174
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
